import type { SVGProps } from "react";
import { memo } from "react";
const CloudTrail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#B0084D" />
        <stop offset="100%" stopColor="#FF4F8B" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M25 52.996h4v-2.002h-4zm34.971-14.833c-.225-3.037-1.71-5.273-4.069-6.063-1.899-.633-3.991-.186-5.584 1.113-.966-1.905-2.418-3.771-3.616-4.953-4.296-4.24-9.034-5.322-14.086-3.215C28.106 26.922 24 33.087 24 37.981v.19c-2.707.915-4.891 2.903-5.926 5.438l1.852.757c1.319-3.23 4.406-4.244 5.321-4.477.443-.113.753-.512.753-.97v-.938c0-4.045 3.657-9.536 7.385-11.088 4.295-1.79 8.193-.882 11.913 2.792 1.582 1.56 3.129 3.876 3.762 5.633a.999.999 0 0 0 1.739.262c1.105-1.47 2.897-2.106 4.47-1.58 1.735.58 2.731 2.397 2.731 4.982a1 1 0 0 0 .836.987c.733.122 7.164 1.383 7.164 8.022 0 6.877-6.719 7.005-7 7.007H36V57h23.002C62.114 56.994 68 55.104 68 47.991c0-6.207-4.721-9.002-8.029-9.828M31 52.996h14v-2.002H31zM27 57h6v-2.002h-6zm-15 0h3v-2.002h-3zm3-8.008h9V46.99h-9zm-2 4.004h10v-2.002H13zm14-4.004h7V46.99h-7zM17 57h8v-2.002h-8z"
      />
    </g>
  </svg>
);
const Memo = memo(CloudTrail);
export default Memo;
